import { Box, Chip, SxProps, Theme, Typography } from '@mui/material';

interface DualListItem {
    name: string;
    label: string;
}

interface DualListPanelProps {
    title: string;
    color: string;
    items: DualListItem[];
    emptyLabel: string;
    boxSx: SxProps<Theme>;
    onRemove?: (name: string) => void;
}

function DualListPanel({ title, color, items, emptyLabel, boxSx, onRemove }: DualListPanelProps) {
    return (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.5, minHeight: 0 }}>
            <Typography variant="caption" sx={{ fontWeight: 600, color }}>
                {title} {onRemove && `(${items.length})`}
            </Typography>
            <Box
                sx={{
                    overflowY: 'auto',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    bgcolor: 'background.paper',
                    px: 1,
                    py: 0.5,
                    ...boxSx,
                }}
            >
                {items.length === 0 ? (
                    <Typography variant="body2" sx={{ color: '#6c757d' }}>
                        {emptyLabel}
                    </Typography>
                ) : onRemove ? (
                    items.map(item => (
                        <Chip key={item.name} size="small" sx={{ m: 0.25 }} label={item.label} onDelete={() => onRemove(item.name)} />
                    ))
                ) : (
                    items.map(item => (
                        <Typography key={item.name} variant="body2" sx={{ color: '#495057' }}>
                            {item.label}
                        </Typography>
                    ))
                )}
            </Box>
        </Box>
    );
}

export default DualListPanel;
